<template>
  <div class="serveEvaluatepage">
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">车主评价</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <div class="serveEvaluate">
      <div class="serverlabellist">
        <div :class="item.select ? 'serverlabel' : 'serverlabel1' " v-for="(item,index) in label" @click="selectlabel(index)">{{item.text}}</div>
      </div>
      <textarea class="serverevaluate" v-model="content" placeholder="展开说说对服务的想法吧......"></textarea>
      <div class="evaluatebottom">
        <div class="evaluatetextbox">
          <div class="evaluatetext">总体评分</div>
          <ul class="star">
            <li v-for="(itemClass,index) in itemClasses" :class="itemClass" class="star-item" @click="stars(index)"
              track-by="index"></li>
            <!--性能优化 track-by 数据不改变时不会重新渲染-->
          </ul>
        </div>
        <div class="evaluatenum">{{score}}分</div>
      </div>

    </div>
    <div class="evaluateconfirm">
      <div class="evaluateconfirmleft" @click="changeanonymous">
        <img class="evaluateconfirmcheck" :src="is_anonymous ? '../../../static/checkdeicon.png' : '../../../static/checkicon.png'" />
        <div class="evaluateconfirmtext">匿名</div>
        <div class="evaluateconfirmtip">匿名会隐藏昵称</div>
      </div>
      <div class="evaluateconfirmbotton" @click="buttonClicked ? '' :  confirm()">立即发布</div>
    </div>
  </div>
</template>

<script>
  import httper from '../../api/http';
  import {
    Toast
  } from 'vant';

  // import { debounce } from "lodash";
  const openLoading = () => {
    Toast.loading({
      message: "加载中",
      duration: 0, // toast不消失
    });
  }
  export default {
    data() {
      return {
        label: [{
          text: "服务热情",
          select: false
        }, {
          text: "店铺大",
          select: false
        }, {
          text: "环境好",
          select: false
        }, {
          text: "服务专业",
          select: false
        }, {
          text: "服务认真",
          select: false
        }],
        labelIndex: 0,
        selectLabel: [], //标签
        score: 0, //分数
        content: "", //评论内容
        id: "", //订单id
        is_anonymous: 0,
        buttonClicked: false
      }
    },
    computed: { //计算属性
      itemClasses() {
        let result = []; // 返回的是一个数组,用来遍历输出星星
        let score = Math.floor(this.score * 2) / 2; // 计算所有星星的数量
        let hasDecimal = score % 1 !== 0; // 非整数星星判断
        let integer = Math.floor(score); // 整数星星判断
        for (let i = 0; i < integer; i++) { // 整数星星使用on
          result.push("on"); // 一个整数星星就push一个CLS_ON到数组
        }
        if (hasDecimal) { // 非整数星星使用half
          result.push("half"); // 类似

        }
        while (result.length < 5) { // 余下的用无星星补全,使用off
          result.push("off");
        }
        return result;
      }
    },
    created() {
      if (this.$route.query.id) {
        this.id = this.$route.query.id
      }
    },
    mounted() {

    },
    methods: {
      //返回上一页
      pageReturn() {
        this.$router.go(-1)
      },
      //返回首页
      pageToIndex() {
        this.$router.push({
          path: "/"
        })
      },
      stars: function(index) {
        this.score = index + 1
      },
      //是否匿名
      changeanonymous() {
        if (this.is_anonymous == 0) {
          this.is_anonymous = 1
        } else {
          this.is_anonymous = 0
        }
      },
      //选择标签
      selectlabel(index) {
        let label = this.label
        let list = []
        for (let i in label) {
          if (i == index) {
            label[i].select = !label[i].select;
          }
        }
        this.label = label

        console.log("label", label)
        // console.log("list",list)
      },
      /**
       * 防重点击
       * @param duration
       * @returns {Promise<any>}
       */
      buttonClickedFun(duration = 0) {
        this.buttonClicked = true
        return new Promise((resolve, reject) => {
          if (duration && typeof duration === 'number') {
            setTimeout(() => {
              this.buttonClicked = false
            }, duration)
          }
          resolve(true)
        })
      },
      confirm() {
        this.buttonClickedFun(2000)
        let requestData = {}
        requestData.source = "service_order"
        requestData.source_id = this.id
        requestData.content = this.content
        requestData.star = this.score
        requestData.is_anonymous = this.is_anonymous
        let tags = []
        let list = this.label
        for (let i in list) {
          if (list[i].select) {
            tags.push(list[i].text)
          }
        }
        requestData.tags = tags
        openLoading()
        this.request("commentcreat", requestData)
      },

      //调用接口
      request(type = '', requestData = {}) {
        let that = this
        switch (type) {
          // 提交评论
          case 'commentcreat':
            httper.post('comment/create', requestData, res => {
              if (res.code === 0) {
                setTimeout(() => {
                  Toast.clear();
                }, 1000)
                this.$toast({
                  message: '感谢您的评价！',
                })
                this.$router.go(-1)
              } else {
                this.$toast({
                  message: res.message || '系统错误',
                })
              }
            }, true)
            break
        }
      },
    }
  }
</script>

<style>
  .serveEvaluatepage {
    background-color: #F8F8FA;
  }

  .serveEvaluate {
    width: 100%;
    margin-top: 20px;
    padding: 20px;
    box-sizing: border-box;
    background-color: #FFFFFF;
  }

  .serverlabellist {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 15px;
  }

  .serverlabel {
    width: 69px;
    height: 23px;
    background: #D9F0FF;
    border: 1px solid #D9F0FF;
    border-radius: 4px;
    font-size: 13px;
    color: #FD8C00;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 5px;
  }

  .serverlabel1 {
    width: 69px;
    height: 23px;
    border: 1px solid #A0A0A0;
    border-radius: 4px;
    font-size: 13px;
    color: #000003;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 5px;
  }

  .serverevaluate {
    width: 100%;
    min-height: 120px;
    border: none;
    outline: none;
    font-size: 14px;
  }

  .evaluatebottom {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .evaluatetextbox {
    display: flex;
    align-items: center;
  }

  .evaluatetext {
    font-size: 14px;
    margin-right: 10px;
  }

  .evaluatenum {
    font-size: 14px;
    color: #FD8C00;
  }


  .evaStar {
    float: left;
    padding-top: .34rem;
  }

  .star {
    font-size: 0;
  }

  .star-item {
    display: inline-block;
    background-repeat: no-repeat;
    width: 1.3rem;
    height: 1.3rem;
    margin-left: .27rem;
    background-size: 100%;
  }

  .star-item.on {
    background-image: url(../../../static/xingpingjia.png);
  }

  .star-item.half {
    background-image: url(../../../static/xingpingjia.png);
  }

  .star-item.off {
    background-image: url(../../../static/xingnone.png);
  }

  .evaluateconfirm {
    width: 100%;
    position: fixed;
    bottom: 0;
    padding: 20px;
    box-sizing: border-box;
    background-color: #FFFFFF;
    border-top: 1px solid #DCDCDC;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .evaluateconfirmleft {
    display: flex;
    align-items: center;
  }

  .evaluateconfirmcheck {
    width: 15px;
    height: 15px;
    margin-right: 7px;
  }

  .evaluateconfirmtext {
    font-size: 15px;
    margin-right: 7px;
  }

  .evaluateconfirmtip {
    font-size: 15px;
    color: #BBBBBB;
  }

  .evaluateconfirmbotton {
    width: 134px;
    height: 38px;
    background: #FD8C00;
    border-radius: 19px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    color: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/pages/offline/serveEvaluate.vue